import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import PricingModal from '../Pricing/PricingModal';
import { Button } from '@/components/ui/button';

interface CreditUpgradeNudgeModalProps {
  isOpen: boolean;
  onClose: () => void;
  usagePercent?: number;
}

/**
 * Aviso de uso elevado (85–99%): CTA de upgrade sem bloquear o agente.
 */
export const CreditUpgradeNudgeModal: React.FC<CreditUpgradeNudgeModalProps> = ({
  isOpen,
  onClose,
  usagePercent,
}) => {
  const [showPricingModal, setShowPricingModal] = React.useState(false);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
        onClick={onClose}
        role="presentation"
      >
        <div
          className="bg-card rounded-lg shadow-2xl p-8 w-full max-w-md border-2 border-orange-500"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-labelledby="credit-nudge-title"
          aria-describedby="credit-nudge-desc"
        >
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 p-3 bg-orange-900/30 rounded-full">
              <ExclamationCircleIcon className="w-16 h-16 text-orange-400" aria-hidden />
            </div>
            <h3 id="credit-nudge-title" className="text-2xl font-bold text-foreground mb-2">
              Uso elevado de créditos
            </h3>
            <p id="credit-nudge-desc" className="text-muted-foreground mb-2">
              Você já utilizou{' '}
              <span className="font-bold text-orange-400">
                {usagePercent != null ? Math.round(usagePercent) : '—'}%
              </span>{' '}
              dos créditos do seu plano.
            </p>
            <p className="text-sm text-muted-foreground mb-6">
              Faça seu upgrade ou aguarde um novo ciclo para renovar seus créditos.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <Button
                type="button"
                onClick={() => setShowPricingModal(true)}
                variant="hero"
                className="flex-1"
              >
                Fazer upgrade
              </Button>
              <Button type="button" onClick={onClose} variant="outline" className="flex-1">
                Entendi
              </Button>
            </div>
          </div>
        </div>
      </div>

      <PricingModal
        isOpen={showPricingModal}
        onClose={() => setShowPricingModal(false)}
        onSelectPlan={() => {
          setShowPricingModal(false);
          onClose();
        }}
      />
    </>
  );
};
